var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { css as emotionCss, cx } from 'emotion';
import { getAutomation, getDebug, useDidUpdate, useEventListener } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isNotNilOrEmpty, isNilOrEmpty, removeKey } from '@pcty/utils';
import { tabPadding } from '../styles/legacy';
import { OuterWrapper as Component, Tabs as XTabs } from './Tabs.styled';
import { container as containerCss, wrapper as wrapperCss } from '../styles/legacy';
import { container as containerCssCitrus2022, wrapper as wrapperCssCitrus2022, tabPadding as tabPaddingCitrus2022, } from '../styles/citron';
export var tabsActiveIdentifier = 'citrus-active-tab-8790q';
export var tabsScrollEndIdentifier = 'citrus-tabs-wrapper-scroll-end-a78fs0d';
export var tabsScrollStartIdentifier = 'citrus-tabs-wrapper-scroll-start-a78fs0d';
var VERSION = '2.13.0';
var ActiveItem = /** @class */ (function (_super) {
    __extends(ActiveItem, _super);
    function ActiveItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActiveItem;
}(Element));
var Tabs = function (_a) {
    var _b;
    var activeIndex = _a.activeIndex, automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, defaultPadding = _a.defaultPadding, onChange = _a.onChange, _c = _a.padding, padding = _c === void 0 ? false : _c, renderBanner = _a.renderBanner, validate = _a.validate, _d = _a.__TYPE, __TYPE = _d === void 0 ? 'Tabs' : _d, other = __rest(_a, ["activeIndex", "automationId", "children", "className", "css", "defaultPadding", "onChange", "padding", "renderBanner", "validate", "__TYPE"]);
    var _e = useState(activeIndex || 0), _activeIndex = _e[0], setActiveIndex = _e[1];
    var citrus2022 = useTheme().citrus2022;
    var refWrapper = useRef(null);
    var refContainer = useRef(null);
    var onResize = function () {
        checkScrollPosition();
    };
    var onScroll = function () {
        checkScrollPosition();
    };
    var checkScrollPosition = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (refContainer.current) {
            try {
                var isAtBeginning = ((_a = refContainer.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) <= 8;
                if (isAtBeginning) {
                    (_b = refWrapper.current) === null || _b === void 0 ? void 0 : _b.classList.add(tabsScrollStartIdentifier);
                }
                else {
                    (_c = refWrapper.current) === null || _c === void 0 ? void 0 : _c.classList.remove(tabsScrollStartIdentifier);
                }
                var isAtEnd = ((_d = refContainer.current) === null || _d === void 0 ? void 0 : _d.scrollLeft) >= ((_e = refContainer.current) === null || _e === void 0 ? void 0 : _e.scrollWidth) - ((_f = refContainer.current) === null || _f === void 0 ? void 0 : _f.offsetWidth) - 8;
                if (isAtEnd) {
                    (_g = refWrapper.current) === null || _g === void 0 ? void 0 : _g.classList.add(tabsScrollEndIdentifier);
                }
                else {
                    (_h = refWrapper.current) === null || _h === void 0 ? void 0 : _h.classList.remove(tabsScrollEndIdentifier);
                }
            }
            catch (error) {
                // do nothing
            }
        }
    };
    useEventListener('resize', onResize);
    useEventListener('scroll', onScroll, refContainer.current);
    useEffect(function () {
        scrollToActive();
        checkScrollPosition();
    }, []);
    useDidUpdate(function () {
        checkScrollPosition();
    }, [children, citrus2022]);
    useEffect(function () {
        if (activeIndex !== undefined) {
            setActiveIndex(activeIndex);
        }
    }, [activeIndex]);
    var scrollToActive = function () {
        var _a, _b;
        var activeItem = (_a = refContainer.current) === null || _a === void 0 ? void 0 : _a.querySelector(".".concat(tabsActiveIdentifier));
        if (!activeItem)
            return;
        var wrapperWidth = (_b = refWrapper.current) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        var activeOffset = activeItem.offsetLeft;
        var activeWidth = activeItem.offsetWidth;
        if (wrapperWidth / 2 > activeOffset + activeWidth)
            return;
        refContainer.current.scrollLeft = activeOffset - wrapperWidth / 2 + activeWidth / 2;
    };
    var handleOnClickTab = function (index) {
        if (activeIndex !== -1) {
            setActiveIndex(index);
            onChange === null || onChange === void 0 ? void 0 : onChange(index);
        }
    };
    var getTabs = function (children, activeIndex, onClick, validate) {
        return React.Children.toArray(children)
            .filter(function (child) { return child.props.__TYPE === 'Tab'; })
            .map(function (x, index) {
            return React.cloneElement(x, {
                __index: index,
                __active: index === activeIndex,
                __onClick: onClick,
                __validate: validate,
            });
        });
    };
    var tabs = getTabs(children, _activeIndex, handleOnClickTab, validate);
    var tabsProps = !automationId ? {} : { 'data-automation-id': automationId };
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b), className || '');
    var getActiveTabContent = function (tabs, renderBanner, index, padding) {
        var tab = tabs.filter(function (x) { return !!x.props.__active; });
        if (isNilOrEmpty(tab))
            return null;
        if (tab[0].props.padding !== false && (tab[0].props.padding || padding)) {
            return (React.createElement("div", null,
                renderBanner && renderBanner(index),
                React.createElement("div", { className: emotionCss(citrus2022 ? tabPaddingCitrus2022 : tabPadding) }, tab[0].props.children)));
        }
        return tab[0].props.children;
    };
    var renderTabContent = function (tabs, renderBanner, index) {
        var content = getActiveTabContent(tabs, renderBanner, index, padding || defaultPadding || false);
        return isNilOrEmpty(content) ? null : content;
    };
    var wrapperStyles = __assign({}, (citrus2022 ? wrapperCssCitrus2022 : wrapperCss));
    var containerStyles = __assign({}, (citrus2022 ? containerCssCitrus2022 : containerCss));
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, __assign({ className: classes }, removeKey(other, 'className'), getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)),
            React.createElement("div", { className: emotionCss(wrapperStyles), ref: refWrapper },
                React.createElement("div", { className: emotionCss(containerStyles), ref: refContainer },
                    React.createElement(XTabs, __assign({}, tabsProps), tabs)))),
        renderTabContent(tabs, renderBanner, _activeIndex)));
};
export default Tabs;
